import $ from 'jquery';
import Popup from '../utilities/Popup';

if ($('.catalog-detail-gallery__item--showreel').length) {
    $('.catalog-detail-gallery__item--showreel').click(function () {
        const images = JSON.parse($('.catalog-detail-showreel__images').attr('data-images')).reverse();
        const image = images.pop();
        images.unshift(image);

        $('.catalog-detail-showreel__images').html(`<img src="${image}"/>`);

        Popup.show('catalog-detail-showreel', 'auto');
        Popup.get('catalog-detail-showreel').find('.popup__content').css('width', 'auto').css('min-width', '66.6vh');
        setTimeout(() => {
            $('.catalog-detail-showreel__images img').reel({
                images,
                steppable: false,
                cursor: 'default',
            });
        }, 1000);
    });

    $(window).keydown(function (e) {
        if (e.key === 'ArrowLeft') {
            $('.catalog-detail-showreel .reel').trigger('stepLeft');
        }

        if (e.key === 'ArrowRight') {
            $('.catalog-detail-showreel .reel').trigger('stepRight');
        }
    });

    let reelInterval = null;
    $('.catalog-detail-showreel__button--left').mousedown(function () {
        $('.catalog-detail-showreel .reel').trigger('stepLeft');
        reelInterval = setInterval(() => {
            $('.catalog-detail-showreel .reel').trigger('stepLeft');
        }, 100);
    });
    $('.catalog-detail-showreel__button--left').mouseup(function () {
        clearInterval(reelInterval);
        reelInterval = null;
    });
    $('.catalog-detail-showreel__button--left').mouseleave(function () {
        clearInterval(reelInterval);
        reelInterval = null;
    });

    $('.catalog-detail-showreel__button--right').mousedown(function () {
        $('.catalog-detail-showreel .reel').trigger('stepRight');
        reelInterval = setInterval(() => {
            $('.catalog-detail-showreel .reel').trigger('stepRight');
        }, 100);
    });
    $('.catalog-detail-showreel__button--right').mouseup(function () {
        clearInterval(reelInterval);
        reelInterval = null;
    });
    $('.catalog-detail-showreel__button--right').mouseleave(function () {
        clearInterval(reelInterval);
        reelInterval = null;
    });


    // используется для проверки это долгий клик, или короткий, при коротком - показывать лупу
    let mouseDownTime = Date.now();
    $('.catalog-detail-showreel__center').mousedown(function () {
        mouseDownTime = Date.now();
    });

    const lensZoom = 2.3;
    let lensIsEnabled = false;
    $('.catalog-detail-showreel__center').click(function () {
        if (Date.now() - mouseDownTime > 700) {
            return;
        }
        if (lensIsEnabled) {
            lensIsEnabled = false;
            $(this).removeClass('catalog-detail-showreel__center--lens');
            $('.catalog-detail-showreel__lens').hide();
        } else {
            lensIsEnabled = true;
            $(this).addClass('catalog-detail-showreel__center--lens');

            const lens = $('.catalog-detail-showreel__lens');
            const lensImage = $('.catalog-detail-showreel__lens img');
            const showreelImage = $('.catalog-detail-showreel__images img');
            const lensHeight = lens.height();
            const lensWidth = lens.width();
            const lensImageHeight = showreelImage.height() * lensZoom;
            const lensImageWidth = showreelImage.width() * lensZoom;

            lensImage.attr('src', showreelImage.attr('src'));

            lensImage.css({
                width: lensImageWidth,
                top: -((lensImageHeight - lensHeight) / 2),
                left: -((lensImageWidth - lensWidth) / 2)
            });

            $('.catalog-detail-showreel__lens').show();
        }
    });

    $('.catalog-detail-showreel__images').on('mousemove', 'img', function (e) {
        if (!lensIsEnabled) {
            return;
        }
        const image = $('.catalog-detail-showreel__lens img');
        const inner = $('.catalog-detail-showreel__lens');

        const mouseY = e.offsetY;
        const thisHeight = $(this).height();
        const imageHeight = image.height();
        const innerHeight = inner.height();

        const mouseCenterOffsetY = (mouseY - (thisHeight / 2)) / (thisHeight / 2);
        const imageCenterOffsetY = (innerHeight - imageHeight) / 2;
        const imageTop = imageCenterOffsetY - (imageHeight / 2) * mouseCenterOffsetY;

        const mouseX = e.offsetX;
        const thisWidth = $(this).width();
        const imageWidth = image.width();
        const innerWidth = inner.width();

        const mouseCenterOffsetX = (mouseX - (thisWidth / 2)) / (thisWidth / 2);
        const imageCenterOffsetX = (innerWidth - imageWidth) / 2;
        const imageLeft = imageCenterOffsetX - (imageWidth / 2) * mouseCenterOffsetX;

        image.css({
            left: imageLeft,
            top: imageTop
        });
    });
}
